/* Nationwide CareMatters Indiana Insurance Application */
import { sharedQuestions } from "./nationwideAppSharedQuestions"
import { sharedSections } from "./nationwideAppSharedSections"
import { FundingPolicyType } from '@shared';
import { nationwideSharedDefs } from './nationwideSharedDefs';
import { nationwidePreApplicationFormDefinition } from '@shared/policy-application/nationwidePreApplicationFormDef';

const questions: Record<string, PolicyFormQuestion> = {
  ...sharedQuestions,
  /* Section 15 - Financial Professionial */
  financialProfessionalHealthPolicies : {
    id: 'fin-pro-health-policies',
    questionRef: "financialProfessionalHealthPolicies",
    title: 'List all other health insurance policies you have sold to the applicant.',
    type: 'text',
    required: true
  },
  financialProfessionalActivePolicies : {
    id: 'fin-pro-active-policies',
    questionRef: "financialProfessionalActivePolicies",
    title: 'List policies you sold to the applicant that are still in force.',
    type: 'text',
    required: true
  },
  financialProfessionalExpiredPolicies : {
    id: 'fin-pro-expired-policies',
    questionRef: "financialProfessionalExpiredPolicies",
    title: 'List policies you sold to the applicant in the past five (5) years that are no longer in force.',
    type: 'text',
    required: true
  },
}

export const nationwideCareMattersINFormDefinition: PolicyFormDefinition = {
  requiredParameters: nationwideSharedDefs.requiredParameters,

  sections: [
    ...nationwidePreApplicationFormDefinition.sections,
      sharedSections.proposedInsured,
      sharedSections.proposedAdditionalInsured,
      sharedSections.policyOwner,
      sharedSections.jointOwner,
      sharedSections.contingentOwner,
      sharedSections.payor,
      sharedSections.beneficiary,
      sharedSections.premiumBilling,
      sharedSections.caremattersIIPlan,
      sharedSections.caremattersTogetherPlan,
      sharedSections.unintendedLapse,
      sharedSections.taxpayerCertification,
      sharedSections.electronicDelivery,
      /* 13 ▸ Insurance Information --------------------------------------------- */
      {
        id: 'insurance-information',
        title: 'Insurance Information',
        subsections: [
          {
            id: 'primary-insured-insurance',
            title: 'Primary Insured Insurance History',
            questionGroups: [
              {
                id: 'primary-current-insurance',
                format: 'default',
                questions: ['primaryInsuredOtherInsurance', 'primaryInsuredSoldPolicy', 'primaryInsuredRecentApplications'],
              },
              {
                id: 'primary-replacement',
                format: 'default',
                questions: ['primaryInsuredReplacement', 'primaryInsuredPastInsurance'],
              },
              {
                id: 'primary-ltc-coverage',
                format: 'default',
                questions: ['primaryInsuredOtherLtc', 'primaryInsuredTerminatedLtc', 'primaryInsuredMedicaid'],
              },
              {
                id: 'primary-intentions',
                format: 'default',
                questions: ['primaryInsuredIntendToStop', 'primaryInsuredReplaceMedical'],
              },
            ],
          },
          {
            id: 'additional-insured-insurance',
            title: 'Additional Insured Insurance History',
            conditional: {
              visible: {
                field: 'fundingPolicyType',
                operator: 'equals' as const,
                value: FundingPolicyType.jointCareMatters,
              },
            },
            questionGroups: [
              {
                id: 'additional-current-insurance',
                format: 'default',
                questions: ['additionalInsuredOtherInsurance', 'additionalInsuredSoldPolicy', 'additionalInsuredRecentApplications'],
              },
              {
                id: 'additional-replacement',
                format: 'default',
                questions: ['additionalInsuredReplacement', 'additionalInsuredPastInsurance'],
              },
              {
                id: 'additional-ltc-coverage',
                format: 'default',
                questions: ['additionalInsuredOtherLtc', 'additionalInsuredTerminatedLtc', 'additionalInsuredMedicaid'],
              },
              {
                id: 'additional-intentions',
                format: 'default',
                questions: ['additionalInsuredIntendToStop', 'additionalInsuredReplaceMedical'],
              },
            ],
          },
            {
            id: 'insurance-coverage-table',
            title: 'Insurance Coverage Details',
            questionGroups: [
              {
                id: 'coverage-table',
                format: 'default',
                questions: ['insuranceCoverageDetails'],
              },
            ],
          },
          {
            id: 'financial-professional-additional',
            title: 'Financial Professional Policy Information',
            questionGroups: [
              {
                id: 'fin-pro',
                format: 'default',
                questions: ['financialProfessionalHealthPolicies', 'financialProfessionalActivePolicies', 'financialProfessionalExpiredPolicies']
              },
            ]
          }
        ],
      },
      sharedSections.financialInformation,
      sharedSections.specialInstructions,
      sharedSections.financialProfessional,
      sharedSections.formAcknowledgment,
      sharedSections.temporaryInsurance,
  ],

  /* ---------- Question record -------------------------------------------------- */
  questions: {
    ...nationwidePreApplicationFormDefinition.questions,
    ...questions,
  },
};